export const MY_DAY_ROUTE = 'myday';
export const ROOM_PANEL_ROUTE = 'roompanel';
export const MEETING_INSIGHTS_ROUTE = 'insights';
export const NOTES_PANE_ROUTE = 'notespane';
export const CALENDAR_WIDGET_ROUTE = 'calendarwidget';
export const TODO_WIDGET_ROUTE = 'todowidget';
export const LOCATION_CARD_ROUTE = 'locationcard';
export const CREATE_GROUP_ROUTE = 'creategroup';
export const ADD_MEMBERS_ROUTE = 'addmembers';
export const EDIT_GROUP_ROUTE = 'editgroup';
export const DISCOVER_GROUP_ROUTE = 'discovergroup';
export const INBOX_RULES_ROUTE = 'inboxrules';
export const DOWNLOAD_MOBILE_ROUTE = 'downloadmobile';
export const DATA_PROVIDER_ROUTE = 'dataprovider';
export const ACTIVITY_FEED_ROUTE = 'activityfeed';
export const YAMMER_ROUTE = 'yammer';
export const YAMMER_PUBLISHER_ROUTE = 'yammerpublisher';
export const LEAVE_GROUP_ROUTE = 'leavegroup';
export const QR_CONNECT_ROUTE = 'qrconnect';
export const SHAREPOINT_PAGE_ROUTE = 'sharepointpage';
export const PLAY_MY_EMAILS_ROUTE = 'playmyemails';
export const TABBED_SEARCH_ROUTE = 'tabbedsearch';
export const FINDTIME_PANE_ROUTE = 'findtimepane';

/** Route registrations for modern OPX app entry point */
export type OpxRoute =
    | typeof MY_DAY_ROUTE
    | typeof ROOM_PANEL_ROUTE
    | typeof MEETING_INSIGHTS_ROUTE
    | typeof NOTES_PANE_ROUTE
    | typeof CALENDAR_WIDGET_ROUTE
    | typeof TODO_WIDGET_ROUTE
    | typeof LOCATION_CARD_ROUTE
    | typeof CREATE_GROUP_ROUTE
    | typeof ADD_MEMBERS_ROUTE
    | typeof EDIT_GROUP_ROUTE
    | typeof DISCOVER_GROUP_ROUTE
    | typeof YAMMER_ROUTE
    | typeof YAMMER_PUBLISHER_ROUTE
    | typeof DOWNLOAD_MOBILE_ROUTE
    | typeof LEAVE_GROUP_ROUTE
    | typeof ACTIVITY_FEED_ROUTE
    | typeof INBOX_RULES_ROUTE
    | typeof DATA_PROVIDER_ROUTE
    | typeof QR_CONNECT_ROUTE
    | typeof SHAREPOINT_PAGE_ROUTE
    | typeof PLAY_MY_EMAILS_ROUTE
    | typeof TABBED_SEARCH_ROUTE
    | typeof FINDTIME_PANE_ROUTE;

/**
 * Route registrations for legacy OPX deeplink entry point, which is slated for deprecation in the near future
 *
 * IMPORTANT: All new OPX component routes should be registered under modern OPX app entry point *ONLY*
 */
export type OpxDeeplinkRoute =
    | typeof ROOM_PANEL_ROUTE
    | typeof MEETING_INSIGHTS_ROUTE
    | typeof LOCATION_CARD_ROUTE
    | typeof CREATE_GROUP_ROUTE
    | typeof ADD_MEMBERS_ROUTE
    | typeof EDIT_GROUP_ROUTE
    | typeof DISCOVER_GROUP_ROUTE
    | typeof INBOX_RULES_ROUTE
    | typeof DOWNLOAD_MOBILE_ROUTE
    | typeof ACTIVITY_FEED_ROUTE
    | typeof YAMMER_ROUTE
    | typeof QR_CONNECT_ROUTE;
